import React from 'react';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';

import BurgerMenu from './burgerMenu';
import { ModalProfile } from './modalProfile';

import Logo from '../assets/img/brand-logo.png';

export default function Navigation({ mobile, account, isAdmin }) {
    const { pathname } = useLocation();

    return (
        <div
            className="navbar-main-2 mb-4"
            style={{
                backgroundColor: `${
                    pathname === '/' ? 'transparent' : '#7367f0'
                }`,
                position: 'relative',
                width: '100%',
            }}
        >
            <div className="container-fluid">
                <div
                    className="navbar-inr-2"
                    style={{
                        padding: '8px 4px',
                        display: 'grid',
                        gridTemplateColumns: '1fr 2fr 1fr',
                    }}
                >
                    <div className="logo-otr">
                        <Link to="/" className="logo-inr">
                            <img className="logo" width="50px" height="50px" src={Logo} alt="brand-logo" />
                        </Link>
                    </div>
                    <div className="navigation-otr mx-auto">
                        <ul className="navigation-inr m-0 p-0">
                            <li className="nav-li">
                                <Link className="nav-a body-sb" to="/">
                                    Home
                                </Link>
                            </li>
                            <li className="nav-li">
                                <Link className="nav-a body-sb" to="/library">
                                    Library
                                </Link>
                            </li>
                            <li className="nav-li">
                                <Link className="nav-a body-sb" to="/contracts">
                                    Contracts
                                </Link>
                            </li>
                            {isAdmin && (
                                <li className="nav-li">
                                    <Link
                                        className="nav-a body-sb"
                                        to="/administration"
                                    >
                                        Administration
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                    {account ? <ModalProfile /> : noConnected()}
                    {mobile ? <BurgerMenu /> : null}
                </div>
            </div>
        </div>
    );
}
function noConnected() {
    return (
        <div className="action-otr ms-auto">
            <Link to="/connect" className="body-sb btn-outline1 btn-wallet">
                Connect
            </Link>
        </div>
    );
}
